<template>
  <div class="motor-settings">
    <div class="unit-container">
      <tabs
        tooltip-key=""
        :label="$t('motor.settings.forceSelection')"
        :options="{
          'newton': $t('motor.settings.newton'),
          'kilogram': $t('motor.settings.kilogram'),
        }"
        v-model="unit"
      ></tabs>
    </div>

    <div class="menu-container">
      <menu-item-number
        tooltip-key="tooltip_motorconfig_pressure"
        :label="$t('motor.settings.workPressure')"
        :link="true"
        @change="setPressure"
        :val="preferences.pressure"
        type="motorconfig_pressure"
        :tab="1"
        unit="bar">
      </menu-item-number>

      <menu-item-number
        tooltip-key="tooltip_motorconfig_oilflow"
        :label="$t('motor.settings.oilFlow')"
        :link="true"
        @change="setLpm"
        :val="preferences.lpm"
        type="motorconfig_lpm"
        :tab="1"
        unit="l/min">
      </menu-item-number>

      <menu-item-number
        tooltip-key="tooltip_motorconfig_omw"
        :label="$t('motor.settings.cc')"
        :link="true"
        @change="setCc"
        :val="preferences.cc"
        type="motorconfig_power"
        :tab="1"
        unit="cc">
      </menu-item-number>

      <menu-item-number
        tooltip-key="tooltip_motorconfig_efficiency"
        label="Efficiëntie"
        :link="false"
        @change="setEfficiency"
        :val="preferences.efficiency"
        type="motorconfig_power"
        :tab="1"
        unit="%">
      </menu-item-number>

      <menu-item
        :label="$t('motor.settings.type')"
        tooltip-key="tooltip_motorconfig_type"
      >
        <input-dropdown
          :options="filteredMotorTypes"
          :value="preferences.selectedMotorType"
          @change="setType"
        />
      </menu-item>
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/hose/components/Tabs';
import { mapGetters } from 'vuex';
import InputField from '@/components/hose/components/InputField';
import MenuItemNumber from '@/components/step2/menu/MenuItemNumber';
import MenuItem from '@/components/step2/menu/MenuItem';
import InputDropdown from '../input/Dropdown';

export default {
  name: 'MotorSettings',
  components: {
    MenuItem,
    MenuItemNumber,
    InputField,
    Tabs,
    InputDropdown,
  },

  computed: {
    ...mapGetters({
      preferences: 'build/motorConfig/getMotorPreferences',
      motorTypes: 'build/motorConfig/getAllMotorTypes',
    }),
    filteredMotorTypes() {
      if (this.motorTypes !== null) {
        let filteredMotorTypes = this.motorTypes;

        filteredMotorTypes = filteredMotorTypes.map((a) => {
          return {key: a.id, value: a.label}
        });

        filteredMotorTypes.unshift({key: 0, value: this.$t('motor.settings.allMotors')});

        return filteredMotorTypes;
      }
    },
    unit: {
      get() {
        return this.preferences.unit;
      },
      set(val) {
        this.$store.commit('build/motorConfig/setUnit', val);
      },
    },
  },

  methods: {
    setType(val) {
      this.$store.commit('build/motorConfig/selectMotorType', val);
    },
    setPressure(val) {
      this.$store.commit('build/motorConfig/setPressure', val)
    },
    setLpm(val) {
      this.$store.commit('build/motorConfig/setLpm', val)
    },
    setCc(val) {
      this.$store.commit('build/motorConfig/setCc', val)
    },
    setEfficiency(val) {
      this.$store.commit('build/motorConfig/setEfficiency', parseInt(val))
    },
  }
};
</script>

<style scoped lang="scss">
.motor-settings {
  grid-row-start: 1;
  grid-row-end: 2;
  color: #3C3C3B;
  padding: 20px 15px;

  @media only screen and (min-width: 768px) {
    padding: 0;
    background-color: unset;
  }
}
.menu-container {
  background-color: #FAFAFA;
  padding-top: 20px;

  @media only screen and (min-width: 768px) {
    padding: 17px 14px 20px 17px;
    border-right: 3px solid #F0F0F0;
    border-bottom: 3px solid #F0F0F0;
    max-width: 270px;
    min-width: 270px;
    margin-top: 20px;
  }
}
</style>